module.exports = __webpack_public_path__ + "img/requisitos.de67297d.png";